import {
    getAllFactoryOrders,
    getAllProduct,
    createNewProductByAdmin,
    updateProductByAdmin,
    getAllUserProducts,
    getPrintableFactoryOrders,
    deleteProductByAdmin,
    getAllProductsToPrint,
} from '../../services/productsService'
import { errorHandler } from '../../utils/errorHandler'
import { productTypes } from './productTypes'
import { notification } from '../notification/notificationActions'

export const getAllFactoryOrdersAction = body => async dispatch => {
    dispatch({
        type: productTypes.GET_ALL_FACTORY_ORDERS_START,
    })
    try {
        const { data } = await getAllFactoryOrders(body)
        const { data: dataAll } = await getPrintableFactoryOrders(body)
        dispatch({
            type: productTypes.GET_ALL_FACTORY_ORDERS_SUCCESS,
            payload: data?.data,
            allProducts: dataAll?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(
            dispatch,
            productTypes.GET_ALL_FACTORY_ORDERS_FAILED,
            error
        )
    }
    dispatch({
        type: productTypes.GET_ALL_FACTORY_ORDERS_END,
    })
}

// export const getPrintableFactoryOrdersAction = (body) => async (dispatch) => {
//     dispatch({
//         type: productTypes.GET_PRINTABLE_FACTORY_ORDERS_START,
//     });
//     try {
//         const { data } = await getPrintableFactoryOrders(body);
//         dispatch({
//             type: productTypes.GET_PRINTABLE_FACTORY_ORDERS_SUCCESS,
//             payload: data?.data,
//             meta: data?.meta,
//         });
//     } catch (error) {
//         errorHandler(
//             dispatch,
//             productTypes.GET_PRINTABLE_FACTORY_ORDERS_FAILED,
//             error
//         );
//     }
//     dispatch({
//         type: productTypes.GET_PRINTABLE_FACTORY_ORDERS_END,
//     });
// };

export const getAllProductsAction = body => async dispatch => {
    dispatch({
        type: productTypes.GET_ALL_PRODUCT_START,
    })
    try {
        const { data } = await getAllProduct(body)
        const { data: allData } = await getAllProductsToPrint(body)
        dispatch({
            type: productTypes.GET_ALL_PRODUCT_SUCCESS,
            payload: data?.data,
            allProductsToPrint: allData?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, productTypes.GET_ALL_PRODUCT_FAILED, error)
    }
    dispatch({
        type: productTypes.GET_ALL_PRODUCT_END,
    })
}

export const getAllUserProductsAction = body => async dispatch => {
    dispatch({
        type: productTypes.GET_ALL_USER_PRODUCT_START,
    })
    try {
        const { data } = await getAllUserProducts(body)
        dispatch({
            type: productTypes.GET_ALL_USER_PRODUCT_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, productTypes.GET_ALL_USER_PRODUCT_FAILED, error)
    }
    dispatch({
        type: productTypes.GET_ALL_USER_PRODUCT_END,
    })
}

export const createNewProductByAdminAction = (
    body,
    tableBody,
    closeModal
) => async (dispatch, getState) => {
    const { allProducts } = getState().product
    dispatch({
        type: productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_START,
    })
    try {
        await createNewProductByAdmin(body)
        const { data } = await getAllProduct(
            tableBody
                ? tableBody
                : {
                      name: '',
                      take: 10,
                      skip: 0,
                  }
        )
        // const copyAllProduct = [...allProducts, { ...body, ...data?.data }];
        dispatch({
            type: productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_SUCCESS,
            payload: data?.data,
            // allOrdersToPrint: [],
            meta: data?.meta,
        })
        dispatch(
            notification({
                message: 'محصول شما با موفقیت ثبت شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_FAILED,
            error,
            allProducts
        )
    }
    dispatch({
        type: productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_END,
    })
}

export const updateProductByAdminAction = (id, body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allProducts } = getState().product
    const index = allProducts.findIndex(
        selectedProduct => selectedProduct.id === id
    )

    dispatch({
        type: productTypes.UPDATE_NEW_PRODUCT_BY_ADMIN_START,
    })
    try {
        const { data } = await updateProductByAdmin(id, body)
        allProducts[index] = data?.data

        dispatch({
            type: productTypes.UPDATE_PRODUCT_BY_ADMIN_SUCCESS,
            payload: allProducts,
        })
        dispatch(
            notification({
                message: `محصول مورد نظر شما شما به روز رسانی شد`,
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            productTypes.UPDATE_PRODUCT_BY_ADMIN_FAILED,
            error,
            allProducts
        )
    }
    dispatch({
        type: productTypes.UPDATE_PRODUCT_BY_ADMIN_END,
    })
}

export const deleteAProductByAdminAction = (
    id,
    closeModal,
    tableBody
) => async (dispatch, getState) => {
    // const { allProducts } = getState().product;
    // const filteredProducts = allProducts.filter((item) => item.id !== id);

    dispatch({
        type: productTypes.DELETE_PRODUCT_BY_ADMIN_START,
    })
    try {
        await deleteProductByAdmin(id)
        const { data } = await getAllProduct(
            tableBody
                ? tableBody
                : {
                      name: '',
                      take: 10,
                      skip: 0,
                  }
        )
        dispatch({
            type: productTypes.DELETE_PRODUCT_BY_ADMIN_SUCCESS,
            payload: data.data,
            allOrdersToPrint: [],
            meta: data?.meta,
        })
        dispatch(
            notification({
                message: 'محصول مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            productTypes.DELETE_PRODUCT_BY_ADMIN_FAILED,
            error
        )
    }
    dispatch({
        type: productTypes.DELETE_PRODUCT_BY_ADMIN_END,
    })
}
